export default __webpack_public_path__ + "static/media/Data points-pana 1.08f6b2a9.png";